import { UseFormReturn } from 'react-hook-form';

import { Flex } from 'components/layout';
import { IntegrationCore } from 'types/Integration';

import { QuickQuoteInputs, TransportTypeOption } from '../../types';
import { QuoteInformationSection as CommonQuoteInformationSection } from '../QuoteInformationSection';

interface QuoteInformationSectionProps {
  formMethods: UseFormReturn<QuickQuoteInputs, any, QuickQuoteInputs>;
  transportTypeOptions: TransportTypeOption[];
  tmsIntegrations?: IntegrationCore[];
}

/** Turvo LTL: Customer and quote info only. Service type and Payment terms are below Items. */
export function QuoteInformationSection({
  formMethods,
  transportTypeOptions: _transportTypeOptions,
  tmsIntegrations: _tmsIntegrations,
}: QuoteInformationSectionProps) {
  return (
    <Flex direction='col' gap='lg' className='w-full'>
      <CommonQuoteInformationSection
        formMethods={formMethods}
        showLTLStaff={false}
        customerRequired
      />
    </Flex>
  );
}
